var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coach-dance-kinds"},_vm._l((_vm.coach.localeSupportedDanceKinds),function(danceKind,index){return _c('span',{key:index},[_vm._v(_vm._s(danceKind))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }